module.exports = __webpack_public_path__ + "static/media/logo-tiny.edd58695.svg";